//TODO theming
export const defaultTheme = {
  defaultLandscape: "https://via.placeholder.com/568x320",
  defaultPortrait: "https://via.placeholder.com/400x600",
  defaultWallpaper: "/assets/images/landscape-placeholder.png",
}
